import { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Star from '@mui/icons-material/Star';
import Loading from './loading';
import { postTicks } from '../utils/api';
import AccountCircle from '@mui/icons-material/AccountCircle';

const TickModal = ({ p, open, onClose, accessToken, isAuthenticated, loginWithRedirect }) => {
  const [stars, setStars] = useState(0);
  const [grade, setGrade] = useState('');
  const [ticked, setTicked] = useState(false);

  useEffect(() => {
    let newTicked = false;
    let newStars = 0;
    let newGrade = p ? p.grade : '';

    if (p && p.ticks) {
      const myTick = p.ticks.find(t => t.isMine);
      if (myTick) {
        newTicked = true;
      }
    }
    setStars(newStars);
    setGrade(newGrade);
    setTicked(newTicked);
  }, [p]);

  const save = () => {
    postTicks(accessToken, -1, p.id, stars, grade)
    .then((data) => {
      onClose(data);
    })
    .catch((error) => {
      console.warn(error);
      alert(error.toString());
    });
  };

  if (!p && open) return <Loading />; // Minimal loading state if needed

  return (
    <Dialog open={open} onClose={() => onClose(p)} aria-labelledby="form-dialog-tick">
      <DialogTitle id="form-dialog-tick">Save ascent</DialogTitle>
      <DialogContent>
        {isAuthenticated && p && (
          <span>
            {ticked && <i>You have already ticked this boulder, do you want to log it again?<br/><br/></i>}
            <Select value={grade} onChange={(e) => setGrade(e.target.value)} input={<Input/>}>
              <MenuItem value="6A">6A</MenuItem>
              <MenuItem value="6A+">6A+</MenuItem>
              <MenuItem value="6B">6B</MenuItem>
              <MenuItem value="6B+">6B+</MenuItem>
              <MenuItem value="6C">6C</MenuItem>
              <MenuItem value="6C+">6C+</MenuItem>
              <MenuItem value="7A">7A</MenuItem>
              <MenuItem value="7A+">7A+</MenuItem>
              <MenuItem value="7B">7B</MenuItem>
              <MenuItem value="7B+">7B+</MenuItem>
              <MenuItem value="7C">7C</MenuItem>
              <MenuItem value="7C+">7C+</MenuItem>
              <MenuItem value="8A">8A</MenuItem>
              <MenuItem value="8A+">8A+</MenuItem>
              <MenuItem value="8B">8B</MenuItem>
            </Select><br/>
            <Select value={stars} onChange={(e) => setStars(Number(e.target.value))} input={<Input/>}>
              <MenuItem value={0}>No stars</MenuItem>
              <MenuItem value={1}><Star /></MenuItem>
              <MenuItem value={2}><Star /><Star /></MenuItem>
              <MenuItem value={3}><Star /><Star /><Star /></MenuItem>
            </Select><br/><br/>
            <ButtonGroup>
              <Button onClick={save} color="primary">Save ascent</Button>
              <Button onClick={() => onClose(p)} color="secondary">Cancel</Button>
            </ButtonGroup>
          </span>
        )}
        {!isAuthenticated && (
          <Button variant="contained" color="primary" fullWidth onClick={() => loginWithRedirect({})}>
            Sign in <AccountCircle/>
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TickModal;